// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"835":"edf2c78b","917":"de5d8395"}[chunkId] + ".chunk.css";
};